import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Alert, TextField,
} from "@mui/material";
import axios from "../../../config/axiosConfig";

const initialForm = { nombre: "", marca: "", detalle: "" };

const RegistrarProductoDialog = ({ open, onClose, onCreado }) => {
  const [form, setForm] = useState(initialForm);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (campo) => (e) => setForm((prev) => ({ ...prev, [campo]: e.target.value }));

  const handleClose = () => {
    if (saving) return;
    setForm(initialForm);
    setError("");
    onClose();
  };

  const handleGuardar = async () => {
    setSaving(true);
    setError("");
    try {
      const { data } = await axios.post("/api/inventario-interno/productos", {
        nombre: form.nombre.trim(),
        marca: form.marca.trim(),
        detalle: form.detalle.trim(),
      });
      setForm(initialForm);
      onCreado(data?.id);
    } catch (e) {
      setError(e?.response?.data?.message || "Error al registrar el producto.");
    } finally {
      setSaving(false);
    }
  };

  const puedeGuardar = form.nombre.trim() && !saving;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 800 }}>Registrar producto</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={1.5} sx={{ mt: 0.5 }}>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField
            size="small" label="Nombre" required
            value={form.nombre} onChange={handleChange("nombre")}
          />
          <TextField
            size="small" label="Marca"
            value={form.marca} onChange={handleChange("marca")}
          />
          <TextField
            size="small" label="Detalle" multiline minRows={2}
            value={form.detalle} onChange={handleChange("detalle")}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={saving}>Cancelar</Button>
        <Button variant="contained" onClick={handleGuardar} disabled={!puedeGuardar}>
          {saving ? "Guardando..." : "Guardar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RegistrarProductoDialog;
